package com.eladfinish.bible.contest.network.spreadsheet

import com.eladfinish.bible.contest.network.ApiResult
import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetRowHeadersAndValues.Companion.toOnlyValues
import com.eladfinish.bible.contest.utils.spreadsheet.getId
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.map

/**
 * Developed by
 * @author Elad Finish
 */

fun getGoogleDocsUrlForDownload(originalGoogleDriveFileUrl: String): String {
    var id = ""
    //"get a sharable link:"
    //https://drive.google.com/open?id=1t2CtJ7nD1ZPYnqbB4odhn1pK-gheyTpY
    //https://drive.google.com/open?id=0B1L3UYEMI3RTOGFkTnZmZkNOR3M
    //https://drive.google.com/file/d/0B1L3UYEMI3RTOGFkTnZmZkNOR3M/view?usp=sharing
    //https://drive.google.com/file/d/0B1L3UYEMI3RTOGFkTnZmZkNOR3M/view
    val prefix = "https://drive.google.com/uc?export=download&id="
    if (originalGoogleDriveFileUrl.contains("/d/")) {
        id = originalGoogleDriveFileUrl.getId()
    } else {
        ".*?\\?id=(.*)".toRegex().find(originalGoogleDriveFileUrl)?.let {
            id = it.groupValues[1]
        }
    }
    return prefix + id
}

fun Flow<List<GoogleSheetRowHeadersAndValues>>.valuesWithoutColumns(): Flow<List<List<String>>> =
    this.map { list: List<GoogleSheetRowHeadersAndValues> ->
        list.toOnlyValues()
    }

// The parsing itself (toSpreadsheetMatrixWithHeadersTest() etc.) lives in :appContent's
// SpreadsheetParsing.kt, shared with the website generator; these wrap it in a Flow.
fun String.toSpreadsheetMatrixWithHeaders(): Flow<List<GoogleSheetRowHeadersAndValues>> =
    flow { emit(value = this@toSpreadsheetMatrixWithHeaders.toSpreadsheetMatrixWithHeadersTest()) }

fun String.toSpreadsheetMatrix(): Flow<List<List<String>>> =
    this.toSpreadsheetMatrixWithHeaders()
        .valuesWithoutColumns()

suspend fun <T> ApiResult<String, Any>.handleApiResult(
    onSuccess: suspend (ApiResult.Success<String, Any>) -> Result<T>,
): Result<T> =
    when (this) {
        is ApiResult.ClientError -> Result.failure(throwable)
        is ApiResult.Failure -> Result.failure(cause)
        is ApiResult.Success -> onSuccess(this)
    }
